module.exports = __webpack_public_path__ + "img/package_bg_1.fd91602f.png";